import { CatValoracion } from "src/app/shared/model/iso42001/matriz-riesgo.model";

/*
 * Colores y filtros de las hojas de criterios del FOS-005 (Estrategias,
 * Ejemplo de amenazas y Apreciación de riesgos). Los usan el libro, que las
 * muestra en su ventana de consulta, y el Plan Gestión RSK, que enseña los
 * criterios de evaluación; la configuración de las hojas de apoyo pinta lo
 * mismo. Deciden por coincidencia parcial y no por el texto exacto, porque
 * los nombres se pueden cambiar en Gestión de Hojas de Apoyo.
 */

/**
 * Un color vivo por categoria del catalogo de amenazas. ERROR/FALLO se evalua
 * antes que INTENCIONADO porque "ERRORES Y FALLOS NO INTENCIONADOS" contiene
 * ambos. Una categoria nueva sale en el azul del sistema.
 */
export function claseDeCategoria(cat?: string): string {
  const t = (cat || "").toUpperCase();
  if (t.includes("NATURAL")) { return "cat-nat"; }
  if (t.includes("INDUSTRIAL")) { return "cat-ind"; }
  if (t.includes("ERROR") || t.includes("FALLO")) { return "cat-err"; }
  if (t.includes("ATAQUE") || t.includes("INTENCIONADO")) { return "cat-ata"; }
  return "cat-otra";
}

/**
 * El color del Excel para cada estrategia; MITIG va antes que EVITAR porque
 * "Mitigar/Eliminar" contiene ambos. Una estrategia nueva sale neutra.
 */
export function claseDeEstrategia(nombre?: string): string {
  const t = (nombre || "").toUpperCase();
  if (t.includes("MITIG")) { return "est-mitigar"; }
  if (t.includes("TRANSFER")) { return "est-transferir"; }
  if (t.includes("ACEPT")) { return "est-aceptar"; }
  if (t.includes("EVITAR") || t.includes("ELIMINAR")) { return "est-evitar"; }
  return "est-neutra";
}

/**
 * El color de la banda de severidad en la tabla de criterios, como en el
 * formato. Antes era un switch sobre "Baja"/"Media"/"Alta"/"Critico"; desde
 * que las bandas se pueden renombrar, bastaba escribir "Crítico" con acento
 * para que la fila se quedara sin color.
 */
export function claseDeCriterio(c?: string): string {
  const t = (c || "").toUpperCase();
  if (t.includes("MUY ALT") || t.includes("CRITIC") || t.includes("CRÍTIC")) {
    return "c-rojo";
  }
  if (t.includes("ALT")) { return "c-naranja"; }
  if (t.includes("MEDI")) { return "c-amarillo"; }
  if (t.includes("BAJ")) { return "c-verde"; }
  return "";
}

/** Los renglones de un catálogo que son de una escala: PROBABILIDAD, IMPACTO, AMENAZA... */
export function deEscala<T extends { aplicaA?: string }>(lista: T[], aplicaA: string): T[] {
  return lista.filter((x) => x.aplicaA === aplicaA);
}

/** Los niveles de una dimensión de la valoración del activo. */
export function deDimension(lista: CatValoracion[], dimension: string): CatValoracion[] {
  return lista.filter((v) => v.dimension === dimension);
}
